import dev from '../../assets/images/dev.svg';
import study from '../../assets/images/study.svg';
import photo from '../../assets/images/photo.svg';
import post from '../../assets/images/post.svg';

export default function getIcon(type) {
  switch (type) {
    case 'dev':
      return dev;
    case 'study':
      return study;
    case 'photo':
      return photo;
    default:
      return post;
  }
}
